module.exports = __webpack_public_path__ + "static/media/che6.c71652bc.png";